import {invoke} from '@tauri-apps/api/core'
import {relaunch} from '@tauri-apps/plugin-process'
import {check} from '@tauri-apps/plugin-updater'
import {ElMessageBox, ElNotification} from 'element-plus'
import {isTauriRuntime} from './tauri'

const confirmUpdate = message => ElMessageBox.confirm(message, 'POS 업데이트', {
  confirmButtonText: '업데이트',
  cancelButtonText: '나중에',
  type: 'info',
})

const checkShellUpdate = async () => {
  const update = await check({timeout: 5_000})
  if (!update) return false

  await confirmUpdate(`Windows 앱 ${update.version} 버전이 있습니다. 지금 업데이트할까요?`)
  await update.downloadAndInstall()
  await relaunch()
  return true
}

const checkFrontendUpdate = async () => {
  const manifest = await invoke('check_frontend_update')
  if (!manifest) return false

  await confirmUpdate(`POS 화면 ${manifest.version} 버전이 있습니다. 지금 업데이트할까요?`)
  const result = await invoke('install_frontend_update', {manifest})
  if (!result.installed) return false

  ElNotification.success({title: '업데이트 완료', message: '새 화면으로 다시 시작합니다.'})
  await relaunch()
  return true
}

export const runStartupUpdates = async () => {
  if (!isTauriRuntime()) return

  try {
    await invoke('mark_frontend_healthy')
  } catch (error) {
    console.warn('Unable to mark the frontend bundle healthy', error)
  }

  try {
    if (await checkShellUpdate()) return
  } catch (error) {
    if (error !== 'cancel') console.warn('Windows app update check failed', error)
  }

  try {
    await checkFrontendUpdate()
  } catch (error) {
    if (error !== 'cancel') console.warn('Frontend update check failed', error)
  }
}
